import React from 'react';
import { hydrate, render } from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import './styles/main.css';
import App from './App';

const rootElement = document.getElementById('root');

if (rootElement && rootElement.hasChildNodes()) {
    hydrate(
        <React.StrictMode>
            <HelmetProvider>
                <App />
            </HelmetProvider>
        </React.StrictMode>,
        rootElement
    );
} else {
    render(
        <React.StrictMode>
            <HelmetProvider>
                <App />
            </HelmetProvider>
        </React.StrictMode>,
        rootElement
    );
}
